import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-950 py-12 border-t border-slate-900 text-sm">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          
          <div className="flex items-center gap-2">
            <span className="font-bold text-slate-200 text-lg">LearnAnimated</span>
          </div>

          <div className="flex gap-6 text-slate-500">
            <a href="#" className="hover:text-cyan-400 transition-colors">About</a>
            <a href="#" className="hover:text-cyan-400 transition-colors">Blog</a>
            <a href="#" className="hover:text-cyan-400 transition-colors">Contact</a>
            <a href="#" className="hover:text-cyan-400 transition-colors">Privacy</a>
          </div>

          <div className="flex gap-4">
             <a href="#" className="text-slate-500 hover:text-cyan-400"><SafeIcon icon={FiIcons.FiTwitter} /></a>
             <a href="#" className="text-slate-500 hover:text-cyan-400"><SafeIcon icon={FiIcons.FiInstagram} /></a>
             <a href="#" className="text-slate-500 hover:text-cyan-400"><SafeIcon icon={FiIcons.FiYoutube} /></a>
          </div>

        </div>
        
        <div className="mt-8 pt-8 border-t border-slate-900 flex justify-between items-center text-slate-600">
          <p>© LearnAnimated. All rights reserved.</p>
          {/* Tiny boat icon signature */}
          <svg width="20" height="20" viewBox="0 0 100 100" fill="currentColor" className="opacity-50">
             <path d="M10,60 L90,60 L75,80 L25,80 Z" />
             <path d="M50,10 L90,60 L50,60 Z" />
             <path d="M50,10 L10,60 L50,60 Z" />
          </svg>
        </div>
      </div>
    </footer>
  );
};

export default Footer;